// Generated by scripts/generate-registry.mjs. Do not edit directly.
export const STATUS_METADATA = [
    {
        code: 100,
        name: 'CONTINUE',
        message: 'Continue',
        reference: 'RFC9110 §15.2.1',
        registryStatus: 'permanent',
    },
    {
        code: 101,
        name: 'SWITCHING_PROTOCOLS',
        message: 'Switching Protocols',
        reference: 'RFC9110 §15.2.2',
        registryStatus: 'permanent',
    },
    {
        code: 102,
        name: 'PROCESSING',
        message: 'Processing',
        reference: 'RFC2518',
        registryStatus: 'permanent',
    },
    {
        code: 103,
        name: 'EARLY_HINTS',
        message: 'Early Hints',
        reference: 'RFC8297',
        registryStatus: 'permanent',
    },
    {
        code: 104,
        name: 'UPLOAD_RESUMPTION_SUPPORTED',
        message: 'Upload Resumption Supported',
        reference: 'draft-ietf-httpbis-resumable-upload-05',
        registryStatus: 'temporary',
    },
    {
        code: 200,
        name: 'OK',
        message: 'OK',
        reference: 'RFC9110 §15.3.1',
        registryStatus: 'permanent',
    },
    {
        code: 201,
        name: 'CREATED',
        message: 'Created',
        reference: 'RFC9110 §15.3.2',
        registryStatus: 'permanent',
    },
    {
        code: 202,
        name: 'ACCEPTED',
        message: 'Accepted',
        reference: 'RFC9110 §15.3.3',
        registryStatus: 'permanent',
    },
    {
        code: 203,
        name: 'NON_AUTHORITATIVE_INFORMATION',
        message: 'Non-Authoritative Information',
        reference: 'RFC9110 §15.3.4',
        registryStatus: 'permanent',
    },
    {
        code: 204,
        name: 'NO_CONTENT',
        message: 'No Content',
        reference: 'RFC9110 §15.3.5',
        registryStatus: 'permanent',
    },
    {
        code: 205,
        name: 'RESET_CONTENT',
        message: 'Reset Content',
        reference: 'RFC9110 §15.3.6',
        registryStatus: 'permanent',
    },
    {
        code: 206,
        name: 'PARTIAL_CONTENT',
        message: 'Partial Content',
        reference: 'RFC9110 §15.3.7',
        registryStatus: 'permanent',
    },
    {
        code: 207,
        name: 'MULTI_STATUS',
        message: 'Multi-Status',
        reference: 'RFC4918',
        registryStatus: 'permanent',
    },
    {
        code: 208,
        name: 'ALREADY_REPORTED',
        message: 'Already Reported',
        reference: 'RFC5842',
        registryStatus: 'permanent',
    },
    {
        code: 226,
        name: 'IM_USED',
        message: 'IM Used',
        reference: 'RFC3229',
        registryStatus: 'permanent',
    },
    {
        code: 300,
        name: 'MULTIPLE_CHOICES',
        message: 'Multiple Choices',
        reference: 'RFC9110 §15.4.1',
        registryStatus: 'permanent',
    },
    {
        code: 301,
        name: 'MOVED_PERMANENTLY',
        message: 'Moved Permanently',
        reference: 'RFC9110 §15.4.2',
        registryStatus: 'permanent',
    },
    {
        code: 302,
        name: 'FOUND',
        message: 'Found',
        reference: 'RFC9110 §15.4.3',
        registryStatus: 'permanent',
    },
    {
        code: 303,
        name: 'SEE_OTHER',
        message: 'See Other',
        reference: 'RFC9110 §15.4.4',
        registryStatus: 'permanent',
    },
    {
        code: 304,
        name: 'NOT_MODIFIED',
        message: 'Not Modified',
        reference: 'RFC9110 §15.4.5',
        registryStatus: 'permanent',
    },
    {
        code: 305,
        name: 'USE_PROXY',
        message: 'Use Proxy',
        reference: 'RFC9110 §15.4.6',
        registryStatus: 'permanent',
    },
    {
        code: 306,
        name: 'UNUSED',
        message: 'Unused',
        reference: 'RFC9110 §15.4.7',
        registryStatus: 'unused',
    },
    {
        code: 307,
        name: 'TEMPORARY_REDIRECT',
        message: 'Temporary Redirect',
        reference: 'RFC9110 §15.4.8',
        registryStatus: 'permanent',
    },
    {
        code: 308,
        name: 'PERMANENT_REDIRECT',
        message: 'Permanent Redirect',
        reference: 'RFC9110 §15.4.9',
        registryStatus: 'permanent',
    },
    {
        code: 400,
        name: 'BAD_REQUEST',
        message: 'Bad Request',
        reference: 'RFC9110 §15.5.1',
        registryStatus: 'permanent',
    },
    {
        code: 401,
        name: 'UNAUTHORIZED',
        message: 'Unauthorized',
        reference: 'RFC9110 §15.5.2',
        registryStatus: 'permanent',
    },
    {
        code: 402,
        name: 'PAYMENT_REQUIRED',
        message: 'Payment Required',
        reference: 'RFC9110 §15.5.3',
        registryStatus: 'permanent',
    },
    {
        code: 403,
        name: 'FORBIDDEN',
        message: 'Forbidden',
        reference: 'RFC9110 §15.5.4',
        registryStatus: 'permanent',
    },
    {
        code: 404,
        name: 'NOT_FOUND',
        message: 'Not Found',
        reference: 'RFC9110 §15.5.5',
        registryStatus: 'permanent',
    },
    {
        code: 405,
        name: 'METHOD_NOT_ALLOWED',
        message: 'Method Not Allowed',
        reference: 'RFC9110 §15.5.6',
        registryStatus: 'permanent',
    },
    {
        code: 406,
        name: 'NOT_ACCEPTABLE',
        message: 'Not Acceptable',
        reference: 'RFC9110 §15.5.7',
        registryStatus: 'permanent',
    },
    {
        code: 407,
        name: 'PROXY_AUTHENTICATION_REQUIRED',
        message: 'Proxy Authentication Required',
        reference: 'RFC9110 §15.5.8',
        registryStatus: 'permanent',
    },
    {
        code: 408,
        name: 'REQUEST_TIMEOUT',
        message: 'Request Timeout',
        reference: 'RFC9110 §15.5.9',
        registryStatus: 'permanent',
    },
    {
        code: 409,
        name: 'CONFLICT',
        message: 'Conflict',
        reference: 'RFC9110 §15.5.10',
        registryStatus: 'permanent',
    },
    {
        code: 410,
        name: 'GONE',
        message: 'Gone',
        reference: 'RFC9110 §15.5.11',
        registryStatus: 'permanent',
    },
    {
        code: 411,
        name: 'LENGTH_REQUIRED',
        message: 'Length Required',
        reference: 'RFC9110 §15.5.12',
        registryStatus: 'permanent',
    },
    {
        code: 412,
        name: 'PRECONDITION_FAILED',
        message: 'Precondition Failed',
        reference: 'RFC9110 §15.5.13',
        registryStatus: 'permanent',
    },
    {
        code: 413,
        name: 'CONTENT_TOO_LARGE',
        message: 'Content Too Large',
        reference: 'RFC9110 §15.5.14',
        registryStatus: 'permanent',
    },
    {
        code: 414,
        name: 'URI_TOO_LONG',
        message: 'URI Too Long',
        reference: 'RFC9110 §15.5.15',
        registryStatus: 'permanent',
    },
    {
        code: 415,
        name: 'UNSUPPORTED_MEDIA_TYPE',
        message: 'Unsupported Media Type',
        reference: 'RFC9110 §15.5.16',
        registryStatus: 'permanent',
    },
    {
        code: 416,
        name: 'RANGE_NOT_SATISFIABLE',
        message: 'Range Not Satisfiable',
        reference: 'RFC9110 §15.5.17',
        registryStatus: 'permanent',
    },
    {
        code: 417,
        name: 'EXPECTATION_FAILED',
        message: 'Expectation Failed',
        reference: 'RFC9110 §15.5.18',
        registryStatus: 'permanent',
    },
    {
        code: 418,
        name: 'IM_A_TEAPOT',
        message: "I'm a teapot",
        reference: 'RFC9110 §15.5.19',
        registryStatus: 'unused',
    },
    {
        code: 421,
        name: 'MISDIRECTED_REQUEST',
        message: 'Misdirected Request',
        reference: 'RFC9110 §15.5.20',
        registryStatus: 'permanent',
    },
    {
        code: 422,
        name: 'UNPROCESSABLE_CONTENT',
        message: 'Unprocessable Content',
        reference: 'RFC9110 §15.5.21',
        registryStatus: 'permanent',
    },
    {
        code: 423,
        name: 'LOCKED',
        message: 'Locked',
        reference: 'RFC4918',
        registryStatus: 'permanent',
    },
    {
        code: 424,
        name: 'FAILED_DEPENDENCY',
        message: 'Failed Dependency',
        reference: 'RFC4918',
        registryStatus: 'permanent',
    },
    {
        code: 425,
        name: 'TOO_EARLY',
        message: 'Too Early',
        reference: 'RFC8470',
        registryStatus: 'permanent',
    },
    {
        code: 426,
        name: 'UPGRADE_REQUIRED',
        message: 'Upgrade Required',
        reference: 'RFC9110 §15.5.22',
        registryStatus: 'permanent',
    },
    {
        code: 428,
        name: 'PRECONDITION_REQUIRED',
        message: 'Precondition Required',
        reference: 'RFC6585',
        registryStatus: 'permanent',
    },
    {
        code: 429,
        name: 'TOO_MANY_REQUESTS',
        message: 'Too Many Requests',
        reference: 'RFC6585',
        registryStatus: 'permanent',
    },
    {
        code: 431,
        name: 'REQUEST_HEADER_FIELDS_TOO_LARGE',
        message: 'Request Header Fields Too Large',
        reference: 'RFC6585',
        registryStatus: 'permanent',
    },
    {
        code: 451,
        name: 'UNAVAILABLE_FOR_LEGAL_REASONS',
        message: 'Unavailable For Legal Reasons',
        reference: 'RFC7725',
        registryStatus: 'permanent',
    },
    {
        code: 500,
        name: 'INTERNAL_SERVER_ERROR',
        message: 'Internal Server Error',
        reference: 'RFC9110 §15.6.1',
        registryStatus: 'permanent',
    },
    {
        code: 501,
        name: 'NOT_IMPLEMENTED',
        message: 'Not Implemented',
        reference: 'RFC9110 §15.6.2',
        registryStatus: 'permanent',
    },
    {
        code: 502,
        name: 'BAD_GATEWAY',
        message: 'Bad Gateway',
        reference: 'RFC9110 §15.6.3',
        registryStatus: 'permanent',
    },
    {
        code: 503,
        name: 'SERVICE_UNAVAILABLE',
        message: 'Service Unavailable',
        reference: 'RFC9110 §15.6.4',
        registryStatus: 'permanent',
    },
    {
        code: 504,
        name: 'GATEWAY_TIMEOUT',
        message: 'Gateway Timeout',
        reference: 'RFC9110 §15.6.5',
        registryStatus: 'permanent',
    },
    {
        code: 505,
        name: 'HTTP_VERSION_NOT_SUPPORTED',
        message: 'HTTP Version Not Supported',
        reference: 'RFC9110 §15.6.6',
        registryStatus: 'permanent',
    },
    {
        code: 506,
        name: 'VARIANT_ALSO_NEGOTIATES',
        message: 'Variant Also Negotiates',
        reference: 'RFC2295',
        registryStatus: 'permanent',
    },
    {
        code: 507,
        name: 'INSUFFICIENT_STORAGE',
        message: 'Insufficient Storage',
        reference: 'RFC4918',
        registryStatus: 'permanent',
    },
    {
        code: 508,
        name: 'LOOP_DETECTED',
        message: 'Loop Detected',
        reference: 'RFC5842',
        registryStatus: 'permanent',
    },
    {
        code: 510,
        name: 'NOT_EXTENDED',
        message: 'Not Extended',
        reference: 'RFC2774',
        registryStatus: 'obsolete',
    },
    {
        code: 511,
        name: 'NETWORK_AUTHENTICATION_REQUIRED',
        message: 'Network Authentication Required',
        reference: 'RFC6585',
        registryStatus: 'permanent',
    },
] as const;
